import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import CancelledReason from '@/models/Shared/CancelledReason';

export default class CancelShiftRequest extends BaseUpdateRequest {
    cancelledReason: CancelledReason;
}